import React from 'react';
import PropTypes from 'prop-types';

const withUserManager = (Wrapped) => {
  let contextTypes = {
    userManager: PropTypes.object.isRequired
  };

  let inner = (props, context) => {
    const { userManager } = context;
    return <Wrapped {...props} userManager={userManager}/>;
  };

  inner.contextTypes = contextTypes;
  return inner;
};

export default withUserManager;



// WEBPACK FOOTER //
// ./src/common/jsx/auth/withUserManager.js